import React from 'react';
import {connect} from 'react-redux';
import {TranslatedLink} from '../containers/Text';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row">

          <div className="footer-copyright col-xs-12 col-sm-6">
            © {(new Date()).getFullYear()} Hermes Germany GmbH
          </div>

          <div className="footer-links col-xs-12 col-sm-6">
            <TranslatedLink href='legal.url' text='legal' key={1} className='footer-link' target='_blank' />
            <TranslatedLink href='security.url' text='security' key={2} className='footer-link' target='_blank' />
            <TranslatedLink href='privacy.url' text='privacy' key={3} className='footer-link' target='_blank' />
{/*             <TranslatedLink href='cookies.url' text='cookies' key={4} className='footer-link' target='_blank' />
 */}          </div>

        </div>
      </div>
    </footer>
  );
};

const mapStateToProps = (state) => ({
  country: state.config.country
});

export default connect(mapStateToProps)(Footer);
